/* Aegean Vibe — Vorschau „Pferd im Wind" (10/2026). Ohne Framework. Rückweg: Datei aus layout/theme.liquid entfernen. */
(function () {
  "use strict";
  var mq = window.matchMedia("(prefers-reduced-motion: reduce)"), reduce = mq.matches;
  var fein = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var conn = navigator.connection || {};
  var sparen = !!(conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || ""));
  var root = document.documentElement;
  var kopf = document.querySelector(".site-header");
  var logo = document.querySelector(".site-header .logo-link .pferd");
  var PAUSE = "av-bewegung-aus", angehalten = false;
  try { angehalten = window.localStorage.getItem(PAUSE) === "1"; } catch (e) {}
  var filme = [], galopp = null;

  function beobachte(el, cb, opt) {
    if (!("IntersectionObserver" in window)) { cb(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting); }); }, opt || { threshold: 0.2 }).observe(el);
  }

  /* Kopfhöhe als CSS-Variable */
  function kopfHoehe() { if (kopf) root.style.setProperty("--kh", kopf.offsetHeight + "px"); }
  kopfHoehe();
  if (kopf && "ResizeObserver" in window) new ResizeObserver(kopfHoehe).observe(kopf);

  /* Mähne im Logo wehen lassen */
  function wehen() {
    if (!logo || reduce || angehalten) return;
    logo.classList.remove("weht"); void logo.getBoundingClientRect(); logo.classList.add("weht");
  }
  if (logo && fein) logo.parentNode.addEventListener("pointerenter", wehen);

  /* Erste Eingabe (für den Hero-Film: kein LCP-Kandidat) */
  var eingabe = false, beiEingabe = [];
  function eingegangen() { if (eingabe) return; eingabe = true; beiEingabe.forEach(function (f) { f(); }); }
  ["scroll", "wheel", "pointermove", "pointerdown", "touchstart", "keydown"].forEach(function (t) {
    window.addEventListener(t, eingegangen, { passive: true, once: true });
  });

  /* Filme: Quelle je Breite, laden erst wenn sichtbar, außerhalb pausieren, Pause-Schalter beachten */
  function film(video, opt) {
    if (!video || reduce || sparen) return;
    opt = opt || {};
    var geladen = false, sichtbar = false, frei = opt.start !== "eingabe";
    function laden() {
      if (geladen) return; geladen = true;
      var schmal = window.innerWidth < 720;
      JSON.parse(video.getAttribute(schmal ? "data-quellen-klein" : "data-quellen") || "[]").forEach(function (x) {
        if (x[1].indexOf("webm") > -1 && !video.canPlayType(x[1])) return;
        var s = document.createElement("source"); s.src = x[0]; s.type = x[1]; video.appendChild(s);
      });
      video.load();
    }
    function an() {
      if (!sichtbar || !frei || angehalten || document.hidden) return;
      laden();
      var p = video.play();
      if (p && p.then) p.then(function () { video.classList.add("da"); }).catch(function () {});
    }
    function aus() { video.pause(); }
    if (!frei) beiEingabe.push(function () { frei = true; an(); });
    beobachte(opt.ziel || video.parentNode, function (v) { sichtbar = v; if (v) an(); else aus(); }, { threshold: opt.schwelle || 0.15 });
    document.addEventListener("visibilitychange", function () { if (document.hidden) aus(); else an(); });
    filme.push({ an: an, aus: aus });
  }

  /* Pause-Schalter (WCAG 2.2.2): hält Filme und Pferd an, Wahl bleibt gespeichert */
  var schalter = [].slice.call(document.querySelectorAll("[data-av-pause]"));
  function setzePause(v) {
    angehalten = v;
    try { window.localStorage.setItem(PAUSE, v ? "1" : "0"); } catch (e) {}
    schalter.forEach(function (b) {
      b.setAttribute("aria-pressed", v ? "true" : "false");
      var t = b.querySelector(".av-pause-t"); if (t) t.textContent = v ? "Bewegung fortsetzen" : "Bewegung anhalten";
    });
    filme.forEach(function (f) { if (v) f.aus(); else f.an(); });
    if (galopp) galopp.pause(v);
  }
  schalter.forEach(function (b) { b.addEventListener("click", function () { setzePause(!angehalten); }); });
  if (angehalten) setzePause(true);
  var mqChange = function (e) { if (e.matches) { reduce = true; setzePause(true); } };
  if (mq.addEventListener) mq.addEventListener("change", mqChange); else if (mq.addListener) mq.addListener(mqChange);

  /* ── Hero „Galopp": galoppiert, fliegt beim ersten Scrollen zeitgesteuert ins Logo ── */
  var hg = document.querySelector("[data-hg]");
  if (hg) galopp = (function () {
    var platz = hg.querySelector(".hg-platz"), pferd = hg.querySelector(".hg-pferd"), svg = pferd.querySelector("svg.galopp");
    var vb = svg.viewBox.baseVal; platz.style.setProperty("--va", (vb.width / vb.height).toFixed(3));
    var SCHWEBE = +(svg.getAttribute("data-schwebe") || 0), TAKT = 90, F = [], N = 0, akt = SCHWEBE, timer = null, lauf = null;
    var zustand = "hero", imBlick = false, intro = false;
    /* Abheben, wenn gut ein Drittel des Hero weggescrollt ist; zurück, wenn wieder fast oben */
    function hoch() { return hg.offsetHeight || 600; }
    function abSchwelle() { return hoch() * 0.35; }
    function zurueckSchwelle() { return hoch() * 0.12; }
    film(hg.querySelector(".hg-schatten video"), { start: "eingabe", ziel: hg, schwelle: 0.1 });

    function sammle() { F = [].slice.call(svg.querySelectorAll(".gf")); N = F.length; }
    function zeige(i) {
      if (N < 2) return;
      F[akt % N].style.visibility = "hidden";
      akt = ((i % N) + N) % N; F[akt].style.visibility = "visible";
    }
    function stopp() { if (timer) { clearTimeout(timer); timer = null; } if (lauf) { clearInterval(lauf); lauf = null; } }
    function auslaufen(danach) {
      var k = 0;
      (function tick() {
        if (akt === SCHWEBE || N < 2) { timer = null; if (danach) danach(); return; }
        zeige(akt + 1);
        timer = setTimeout(tick, Math.round(TAKT * (1 + 1.4 * Math.pow(Math.min(k++, 8) / 8, 2))));
      })();
    }
    function galoppiere(schritte) {
      if (reduce || angehalten || N < 2) return;
      stopp(); var k = 0;
      (function tick() { zeige(akt + 1); if (++k < schritte) timer = setTimeout(tick, TAKT); else auslaufen(); })();
    }
    sammle();
    if (reduce) { logoZeigen(); return { pause: function () {} }; }

    /* Alle 11 Phasen nachladen (Ruhepose steht schon im HTML) */
    function bereit() {
      if (imBlick && !intro && zustand === "hero" && !angehalten) { intro = true; setTimeout(function () { galoppiere(2 * N); }, 450); }
    }
    var sprite = svg.getAttribute("data-sprite");
    function holen() {
      if (!sprite || !window.fetch) return;
      fetch(sprite).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, "image/svg+xml"), g = doc.querySelector("g[fill]");
        if (!g) return;
        var neu = document.importNode(g, true);
        [].forEach.call(neu.querySelectorAll(".gf"), function (f, i) { f.style.visibility = i === SCHWEBE ? "visible" : "hidden"; });
        svg.replaceChild(neu, svg.querySelector("g[fill]")); sammle(); akt = SCHWEBE; bereit();
      }).catch(function () {});
    }
    if (document.readyState === "complete") holen(); else window.addEventListener("load", holen);
    beobachte(platz, function (v) { imBlick = v; bereit(); }, { threshold: 0.3 });

    /* Flugebene: über dem Header, klickdurchlässig */
    var flieger = document.createElement("div");
    flieger.className = "hg-flug"; flieger.setAttribute("aria-hidden", "true");
    document.body.appendChild(flieger);
    function logoVerstecken() { root.classList.add("av-pferd-unterwegs"); }
    function logoZeigen() { root.classList.remove("av-pferd-unterwegs"); }
    function pfad(a, z) {
      var W = window.innerWidth, H = window.innerHeight;
      var acx = a.left + a.width / 2, acy = a.top + a.height / 2, zcx = z.left + z.width / 2, zcy = z.top + z.height / 2, s = z.width / a.width;
      function t(cx, cy, sx, sy) { return "translate(" + (cx - a.width / 2).toFixed(1) + "px," + (cy - a.height / 2).toFixed(1) + "px) scale(" + sx.toFixed(3) + "," + sy.toFixed(3) + ")"; }
      return [
        { transform: t(acx, acy, 1, 1), offset: 0 },
        { transform: t(acx - W * 0.02, acy - H * 0.09, -0.9, 0.9), offset: 0.22 },          /* wenden und steigen */
        { transform: t(zcx + W * 0.16, zcy + Math.min(H * 0.1, 96), -0.42, 0.42), offset: 0.62 }, /* unter dem Header zum Logo */
        { transform: t(zcx + W * 0.015, zcy + 4, -s * 1.12, s * 1.12), offset: 0.85 },
        { transform: t(zcx, zcy, s, s), offset: 1 }                                           /* zurückwenden, im Logo landen */
      ];
    }
    function flug(richtung, fertig) {
      var a = platz.getBoundingClientRect(), z = logo.getBoundingClientRect();
      var dauer = richtung === "hin" ? (window.innerWidth < 861 ? 950 : 1150) : 800;
      flieger.style.width = a.width + "px"; flieger.style.height = a.height + "px";
      flieger.appendChild(svg); flieger.classList.add("an");
      stopp(); lauf = setInterval(function () { zeige(akt + 1); }, 75);
      var opt = { duration: dauer, easing: richtung === "hin" ? "cubic-bezier(.45,0,.2,1)" : "cubic-bezier(.23,1,.32,1)", fill: "forwards", direction: richtung === "hin" ? "normal" : "reverse" };
      var bahn = flieger.animate(pfad(a, z), opt);
      flieger.animate([{ opacity: 1, offset: 0 }, { opacity: 1, offset: 0.86 }, { opacity: 0, offset: 1 }], opt);
      if (richtung === "hin") setTimeout(logoZeigen, dauer * 0.86); else logoVerstecken();
      bahn.onfinish = function () { if (lauf) { clearInterval(lauf); lauf = null; } fertig(); };
    }
    function abheben() {
      if (zustand !== "hero" || angehalten || !logo) return;
      zustand = "fliegt";
      flug("hin", function () {
        flieger.classList.remove("an"); zeige(SCHWEBE); zustand = "gelandet"; wehen();
        if (window.scrollY <= zurueckSchwelle()) zurueck();
      });
    }
    function zurueck() {
      if (zustand !== "gelandet" || angehalten) return;
      zustand = "zurueck";
      flug("zurueck", function () {
        pferd.appendChild(svg); flieger.classList.remove("an"); flieger.getAnimations().forEach(function (x) { x.cancel(); });
        zustand = "hero"; auslaufen();
        if (window.scrollY > abSchwelle()) abheben();
      });
    }
    /* Start: oben = Pferd im Hero, Logo wartet; weiter unten = schon gelandet */
    if (window.scrollY > abSchwelle() || angehalten) { logoZeigen(); if (!angehalten) { flieger.appendChild(svg); zustand = "gelandet"; } }
    else logoVerstecken();
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (zustand === "hero" && y > abSchwelle()) abheben();
      else if (zustand === "gelandet" && y <= zurueckSchwelle()) zurueck();
    }, { passive: true });
    return {
      pause: function (v) {
        if (v) { stopp(); if (zustand === "hero") logoZeigen(); }
        else if (zustand === "hero" && window.scrollY <= abSchwelle()) logoVerstecken();
      }
    };
  })();

  /* ── Produktbühne „Brise": Film nur, wenn im Theme-Editor eingeschaltet ── */
  [].forEach.call(document.querySelectorAll("[data-brise]"), function (sec) { film(sec.querySelector(".br-film video"), { schwelle: 0.4, ziel: sec }); });

  /* ── Versprechen „Olivenschatten" ── */
  [].forEach.call(document.querySelectorAll("[data-schatten]"), function (sec) { film(sec.querySelector(".sv-film"), { ziel: sec, schwelle: 0.2 }); });

  /* ── Marken-Slider: Pfeile mit Endzustand, Fokus folgt ── */
  [].forEach.call(document.querySelectorAll("[data-ms]"), function (sec) {
    var reihe = sec.querySelector("[data-ms-reihe]"), pfeile = [].slice.call(sec.querySelectorAll("[data-ms-richtung]"));
    function kachelBreite() { var k = reihe.querySelector(".ms-kachel"); return k ? k.getBoundingClientRect().width + 16 : 276; }
    function zustand() {
      var max = reihe.scrollWidth - reihe.clientWidth - 2;
      pfeile.forEach(function (b) {
        var aus = +b.getAttribute("data-ms-richtung") < 0 ? reihe.scrollLeft <= 2 : reihe.scrollLeft >= max;
        b.setAttribute("aria-disabled", aus ? "true" : "false");
      });
    }
    pfeile.forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.getAttribute("aria-disabled") === "true") return;
        reihe.scrollBy({ left: +b.getAttribute("data-ms-richtung") * kachelBreite() * 2, behavior: reduce ? "auto" : "smooth" });
      });
    });
    reihe.addEventListener("scroll", zustand, { passive: true });
    window.addEventListener("resize", zustand, { passive: true });
    reihe.addEventListener("focusin", function (e) {
      var k = e.target.closest(".ms-kachel"); if (!k) return;
      var r = k.getBoundingClientRect(), b = reihe.getBoundingClientRect(), rand = parseFloat(getComputedStyle(reihe).scrollPaddingLeft) || 18;
      if (r.left < b.left + rand || r.right > b.right - rand) reihe.scrollTo({ left: k.offsetLeft - rand, behavior: reduce ? "auto" : "smooth" });
    });
    zustand();
  });

  /* ── Handy-Menü: Fokus führen, Hintergrund inert, aria-expanded ── */
  var burger = document.querySelector(".burger"), drawer = document.getElementById("MobileMenu");
  if (burger && drawer && "MutationObserver" in window) {
    var aussen = [document.getElementById("MainContent"), document.querySelector(".site-footer"), kopf];
    new MutationObserver(function () {
      var offen = !drawer.hasAttribute("hidden");
      burger.setAttribute("aria-expanded", offen ? "true" : "false");
      aussen.forEach(function (el) { if (el) el.inert = offen; });
      if (offen) { var c = drawer.querySelector(".mm-close"); if (c) c.focus(); }
      else if (drawer.contains(document.activeElement) || document.activeElement === document.body) burger.focus();
    }).observe(drawer, { attributes: true, attributeFilter: ["hidden"] });
    drawer.addEventListener("keydown", function (e) {
      if (e.key !== "Tab") return;
      var f = [].slice.call(drawer.querySelectorAll("a[href], button")), erst = f[0], letzt = f[f.length - 1];
      if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
      else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
    });
  }
})();

/* Warenkorb „Passt dazu": Hinzufügen ohne Neuladen → seit 06.10.2026 in assets/warenkorb.js */

